<template>
  <div>
        <div class="layui-card" style="min-height:800px">
            <div class="layui-card-body">
                <div class="layui-form  layui-form-pane" lay-filter="example">
                    <p class="titleProject">项目基本信息</p>
                    <table class="layui-table" style="width: 100%;">
                        <colgroup>
                            <col width="150">
                            <col width="200">
                            <col>
                        </colgroup>
                        <tbody>
                            <tr>
                                <td class="JBtitle">项目编号:</td>
                                <td class="JBvalue" id="PrjNo">
                                    {{bulletinList.PrjNo}}
                                    </td>
                                <td class="JBtitle">项目名称:</td>
                                <td class="JBvalue" id="PrjName">
                                    {{bulletinList.PrjName}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">采购单位:</td>
                                <td class="JBvalue" id="YzCompanyName">
                                    {{bulletinList.YzCompanyName}}
                                    </td>
                                <td class="JBtitle">经办人:</td>
                                <td class="JBvalue" id="YzCompanyLinkMan">
                                    {{bulletinList.YzCompanyLinkMan}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">联系电话:</td>
                                <td class="JBvalue" id="YzCompanyLinkPhone">
                                    {{bulletinList.YzCompanyLinkPhone}}
                                    </td>
                                <td class="JBtitle">标书售价(元):</td>
                                <td class="JBvalue" id="BookSellMoney">
                                    {{bulletinList.BookSellMoney}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">保证金金额(元):</td>
                                <td class="JBvalue" id="BidDeposit">
                                    {{bulletinList.BidDeposit}}
                                    </td>
                                <td class="JBtitle">报名时间:</td>
                                <td class="JBvalue" id="SignTimeStr">
                                    {{bulletinList.SignUpDate + " - " + bulletinList.SignUpEndDate}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">报价时间:</td>
                                <td class="JBvalue" id="KbTimeStr">
                                    {{bulletinList.ZTBTypeId=="0208"?bulletinList.KbDate + " - " + bulletinList.KbEndDate:bulletinList.SignUpDate + " - " + bulletinList.KbEndDate}}
                                    </td>
                                <td class="JBtitle">品目分类:</td>
                                <td class="JBvalue" id="CallingName">
                                    {{bulletinList.CallingName}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">项目预算:</td>
                                <td class="JBvalue" id="KbTimeStr">
                                    {{bulletinList.ProjectBudget}} 万元
                                </td>
                                <td class="JBtitle">报价方式:</td>
                                <td class="JBvalue" id="CallingName">
                                    {{bulletinList.QuoteType=="0"?"往下报":"往上报"}}/{{bulletinList.QuoteRemark}}
                                    </td>
                            </tr>
                            <tr class="EnterCustomerClassDiv" style="display:none;">
                                <td class="JBtitle">是否启用合格供应商库:</td>
                                <td class="JBvalue" id="isEnterCustomerTxt" colspan=3>
                                    {{bulletinList.isEnterCustomer == "1" ? "是" : "否"}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">采购内容:</td>
                                <td class="JBvalue" id="Remark" colspan=3>
                                    {{bulletinList.PrjContent}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">商务要求:</td>
                                <td class="JBvalue" id="Remark" colspan=3>
                                    {{bulletinList.Remark}}
                                    </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="bulletinList" class="layui-from PhoneTab">
                    <p class="titleProject">
                        采购物品清单
                    </p>
                    <!-- <span v-for="item in bulletinList.SectProductList" :key="item.key"> -->
                    <span v-for="(item,index) of bulletinList.SectProductList"  :key="index">
                        <p  class="titleProject" style="font-weight: 500;">标段名称：{{item.SectName}}</p>
                        <table class="layui-table" style="width: 100%;">
                            <tbody>
                                <tr>
                                    <td>序号</td>
                                    <td>货物或服务名称</td>
                                    <td>品牌</td>
                                    <td>规格型号</td>
                                    <td>预算单价</td>
                                    <td>数量</td>
                                    <td>单位</td>
                                    <td>预算总价</td>
                                    <td>配置及技术指标</td>
                                </tr>
                                <tr v-for="(item2,index2) of item.Data" :key="index2">
                                    <td>{{ index2+1 }}</td>
                                    <td>{{ item2.Name }}</td>
                                    <td>{{ item2.Brand }}</td>
                                    <td>{{ item2.Model }}</td>
                                    <td>{{ item2.UnitPrice + (item2.UnitPriceUnit== "0" ? "元" : "%") }}</td>
                                    <td>{{ item2.Quantity }}</td>
                                    <td>{{ item2.Unit }}</td>
                                    <td>{{ item2.TotalBudget + (item2.UnitPriceUnit== "0" ? "元" : "%") }}</td>
                                    <td>{{ item2.Remarks }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </span>
                    <!-- <el-table style="width: 100%" bordered :data="bulletinList.ProductList" :rowKey="record=>record.Name" :pagination="false">
                        <el-table-column
                        type="index"
                        label="序号">
                        </el-table-column>
                        <el-table-column
                        prop="Name"
                        label="货物或服务名称" />
                        <el-table-column
                        prop="Brand"
                        label="品牌" />
                        <el-table-column
                        prop="Model"
                        label="规格型号" />
                        <el-table-column
                        prop="UnitPrice"
                        label="预算单价">
                            <template slot-scope="scope">
                                {{ scope.row.UnitPrice + (scope.row.UnitPriceUnit== "0" ? "元" : "%") }}
                            </template>
                        </el-table-column>
                        <el-table-column
                        prop="Quantity"
                        label="数量" />
                        <el-table-column
                        prop="Unit"
                        label="单位" />
                        <el-table-column
                        prop="TotalBudget"
                        label="预算总价">
                            <template slot-scope="scope">
                                {{ scope.row.TotalBudget + (scope.row.UnitPriceUnit== "0" ? "元" : "%") }}
                            </template>
                        </el-table-column>
                        <el-table-column
                        prop="Remarks"
                        label="配置及技术指标" />
                    </el-table> -->
                </div>
                <div v-if="fileList.length>0">
                    <div style="height: 35px;width: 100%;border-bottom: 1px solid #f0f0f0;margin-bottom: 35px;"></div>
                    <div style="padding: 0 25px;" v-for="(item,index) of fileList" :key="index">
                        <a :href="'/fileserver/api/download/' + item.FileId">
                            {{ item.FileName }}
                        </a>
                    </div>
                </div>
                <div class="layui-from">
                    <div class="titleProject" style="color: red;">
                        1.登录网上投标系统进入[网上报名]-[项目报名]，先进行报名<br>
                        2.支付保证金（如有）<br>
                        3.电子竞价一次报价: 进入[电子竞价一次报价]输入所报价格完成报价<br>
                        4.采购人要求上传报价清单的，应根据公告要求，使用项目公告附件中的报价单模板或在报价之后点击[生成/下载报价单]，上传加盖公章后的报价清单(如涉及)<br>
                        5.采购人要求上传报价清单以外的其他材料的，应按采购人公告的格式要求上传（如涉及）<br>
                        技术支持电话: 15381628176
                    </div>
                </div>
                <div class="layui-from" style="text-align:center">
                    <button v-if="wjs" id="wjs" class="layui-btn layui-btn-normal" @click="baojia()">我要报价</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    customRender: (text, record, index) => `${index + 1}`,
    width: 70
  },
  {
    title: '货物或服务名称',
    dataIndex: 'Name',
    width: 180
  },
  {
    title: '品牌',
    dataIndex: 'Brand',
    width: 100
  },
  {
    title: '规格型号',
    dataIndex: 'Model',
    width: 150
  },
  {
    title: '预算单价',
    dataIndex: 'UnitPrice',
    slots: { title: 'UnitPrice' },
    scopedSlots: { customRender: 'UnitPrice' },
    width: 120
  },
  {
    title: '数量',
    dataIndex: 'Quantity',
    width: 100
  },
  {
    title: '单位',
    dataIndex: 'Unit',
    width: 70
  },
  {
    title: '预算总价',
    dataIndex: 'TotalBudget',
    slots: { title: 'TotalBudget' },
    scopedSlots: { customRender: 'TotalBudget' },
    width: 120
  },
  {
    title: '配置及技术指标',
    dataIndex: 'Remarks',
    width: 200
  }
]
export default {
  name: 'bulletin-text',
  props: {
    TextList: {
      type: Object,
      default () {
        return {
          prjId: ''
        }
      }
    }
  },
  data () {
    return {
      columns,
      bulletinList: {},
      fileList: [],
      wjs: true
    }
  },
  created () {
    this.$http.get('/ztbapi/api/Notoken/GetOnlineInquire?PrjId=' + this.$route.query.prjId).then((res) => {
      this.bulletinList = res.data.Body.Data
      this.fileList = res.data.Body.Data.fileList
      var date = new Date()
      var myDate = new Date(date).getTime()
      var jsDate = new Date(res.data.Body.Data.KbEndDate).getTime()
      if (jsDate < myDate) {
        this.wjs = false
      }
    })
  },
  methods: {
    baojia () {
      window.open('/wstb/login.html?PrjId=' + this.TextList.prjId, '_blank')
    }
  }
}
</script>
<style lang="less">
        body {
            padding-top: 0px !important;
        }

        .dtree-theme-item-this {
            background-color: transparent !important;
        }

        .JBtitle {
            background-color: #FBFBFB;
            width: 17%;
            text-align: center;
        }

        .JBvalue {
            width: 33%;
        }

        /*       .layui-input,
        .layui-textarea {
            border-width: 0px;
        }*/

        textarea {
            resize: none;
        }

        .layui-form-label {
            width: 16% !important;
        }

        .layui-input-inline {
            width: 30% !important;
        }

        .layui-input-block {
            margin-left: 230px !important;
        }

        #Remark {
            width: 80% !important;
            line-height: 36px;
            min-height: 38px;
            border: 1px solid #e6e6e6;
            box-sizing: border-box;
        }

        .layui-table-cell {
            height: auto;
            overflow: visible;
            text-overflow: inherit;
            white-space: normal;
        }
        .titleProject {
            color: #222;
            margin: 0;
            font-size: 16px;
            padding: 16px 24px 6px 24px;
            font-weight: bold;
        }

        #ProjectEdit .layui-form-label {
            width: 32%;
        }

        #ProjectEdit .layui-form-item .layui-input-inline {
            width: 40%;
        }

        /* 修改layui */
        .layui-form-item .layui-inline{
            margin-bottom: 0px;
        }
        .layui-form-item .layui-form-checkbox[lay-skin=primary]{
            margin-top: 0;
        }
        td{
            padding: 9px 15px!important;
        }
        .layui-btn {
            display: inline-block;
            height: 38px;
            line-height: 38px;
            padding: 0 18px;
            background-color: #1E9FFF;
            color: #fff;
            white-space: nowrap;
            text-align: center;
            font-size: 14px;
            border: none;
            border-radius: 2px;
            cursor: pointer;
        }
        table td, table th {
            border-bottom: 1px solid #e6e6e6!important;
            border-right: 2px solid #e6e6e6!important;
        }
        table {
            border-top: 1px solid #e6e6e6!important;
            border-left: 1px solid #e6e6e6!important;
        }
        .el-table{
            font-size: 14px!important;
        }
        .layui-card .el-table__empty-block{
            width: 1530px!important;
        }
        .layui-card table{
            width: 1530px!important;
        }
        .layui-card col{
            width: 180px!important;
        }
</style>
<style scoped>
    .el-table__empty-block{
        width: 1530px;
    }
    .PhoneTab div div table{
        width: 1530px;
    }
</style>



// WEBPACK FOOTER //
// src/components/BulletinTab/bulletin.vue